/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import {
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
} from '@material-ui/core';
import ExportExcelR from './ExportExcelR';

import { formatCurrency } from '../../../../service/utils';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#303474",
    color: "white",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

export default function ResumTable({
  docs,
}) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [monthKeys, setMonthKeys] = useState([]);
  const [dataExcel, setDataExcel] = useState(null);

  useEffect(() => {
    if (docs && docs.length > 0) {
      const allKeys = new Set();

      docs.forEach(d => {
        if (d.months) {
          Object.keys(d.months).forEach(key => allKeys.add(key));
        }
      });

      const sortedMonths = Array.from(allKeys).sort((a, b) => {
        const [monthA, yearA] = a.split('/');
        const [monthB, yearB] = b.split('/');
        return new Date(yearA, monthA - 1) - new Date(yearB, monthB - 1);
      });

      setMonthKeys(sortedMonths);
      setRows(docs);

      const listExcel = docs.map(row => {
        const excelRow = {
          Categoria: row.category
        };
        sortedMonths.forEach(month => {
          excelRow[month] = Number(row.months?.[month] || 0);
        });
        excelRow['Valor Total'] = Number(row.amount || 0);

        return excelRow;
      });

      setDataExcel({ Relatorio: listExcel });
    }
  }, [docs]);

  const mountDataExcel = d => {
    return <ExportExcelR allData={d} />;
  };

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Categoria</StyledTableCell>
              {monthKeys.map((month) => (
                <StyledTableCell key={month} >{month}</StyledTableCell>
              ))}
              <StyledTableCell> <div style={{ display: 'flex', justifyContent: 'space-between', paddingRight:'10px' }}>
                Valor total {dataExcel && mountDataExcel(dataExcel)}
              </div></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <StyledTableRow key={i}>
                  <StyledTableCell>{row.category}</StyledTableCell>
                  {monthKeys.map((month) => (
                    <StyledTableCell key={month} >
                      {formatCurrency(row.months[month] || 0)}
                    </StyledTableCell>
                  ))}
                  <StyledTableCell> {formatCurrency(row.amount)}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
